import { Heading, Box, Text, Stack } from 'braid-design-system';
import React from 'react';

const IntroForm = () => (
  <Stack space="large">
    <Box
      textAlign={{
        mobile: 'center',
        desktop: 'left',
      }}
    >
      <Heading level="1">Enquire about a SEEK Company Profile</Heading>
    </Box>
    <Text>
      Please complete this short form and a member from our customer service
      team will be in touch soon with next steps.
    </Text>
  </Stack>
);

export default IntroForm;
